import React, { useContext, useRef } from 'react';
import { Drawer, Fade, Paper } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useTranslation } from "react-i18next";
import { MenuButtonStyle } from './styles';
import { UIContext } from '../../../../context/UIContext';
import DashboardFiltersPanel from '../filters/DashboardFiltersPanel';
import { DashboardFiltersContext } from '../filters/DashboardFiltersContext';
import ToolButton from '../../../../components/ToolButton';

const FiltersDashboard = () => {
    const { t } = useTranslation();
    const { isMobile, isTablet } = useContext(UIContext);

    const { openFilters, closeFilters, filtersOpen } = useContext(DashboardFiltersContext);
    const toggleFilters = () => filtersOpen ? closeFilters() : openFilters();
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const style = {
        ...MenuButtonStyle,
        ...(filtersOpen
                        ? {
                            color: 'primary.main',
                        }
                        : {
                            color: 'text.secondary',
                            backgroundColor: 'background.paper',
                        }),
        padding: '10px 24px',
        backgroundColor: 'background.paper'
    }

    return (
        <>
        <ToolButton 
            buttonStyle={style}
            iconElement={<FilterListIcon/>}
            onClick={toggleFilters}
            text={t('screens.dashboarding.filters')}
            tooltip={t('components.filters.filterList')}
            active={filtersOpen}
            dataQaId="tableFiltersButtonMobile"
            hideTextOnMobileView={false}
            buttonRef={buttonRef}
        /> 
        {!(isTablet || isMobile) &&
            <Drawer 
                open={filtersOpen} 
                anchor="right" 
                hideBackdrop
                ModalProps={{
                    BackdropProps: {
                      invisible: true,
                    },
                    disableEnforceFocus: true,
                    disableRestoreFocus: true,
                    style: { pointerEvents: 'none' }
                  }}
                  PaperProps={{
                    sx: {
                      pointerEvents: 'auto'
                    }
                  }}
                >
                <Fade mountOnEnter unmountOnExit in>
                    <Paper
                        sx={{
                            width: '450px',
							height: { md: 'calc(100vh - 355px)', lg: 'calc(100vh - 310px)'},
                            marginTop: { xs: '5px', sm: '9px', md: '7px' },
                            position: 'fixed',
                            right: '24px',
                            top: { md: '348px', lg: '304px', xl:'304px' },
                            overflow: 'auto',
                            borderRadius: '0px',
                            boxShadow:
                            '0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
                            clipPath: 'inset(0px 0px 0px -74px)',
                            backgroundColor: 'background.paper',
                            backgroundImage: 'none'
                        }}
                    >
                        <DashboardFiltersPanel />
                    </Paper>
                </Fade>
            </Drawer>
            }
        </>
)
}

export default FiltersDashboard;
